import superagent from 'superagent'

export const tracksSet = tracks => ({
  type: 'TRACKS_SET',
  payload: tracks
})

export const trackCreate = track => ({
  type: 'TRACK_CREATE',
  payload: track
})

export const trackUpdate = track => ({
  type: 'TRACK_UPDATE',
  payload: track
})

export const trackDelete = id => ({
  type: 'TRACK_DELETE',
  payload: id
})

export const trackFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/measurement/get?activityId=1&measurementType=1`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
        dispatch(tracksSet(res.body))
      })
  })
}

export const trackCreateRequest = trackObj => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .post(`${__API_URI__}/measurement/create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(trackObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        dispatch(trackCreate(res.body))
        resolve(res.body)
      })
  })
}

export const trackUpdateRequest = trackObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI__}/measurement/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(trackObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
          reject(err)
          return
        }
        // Hydrate the associated photo so consumers that render the track's map
        // thumbnail (my-content-item reads data.photo.thumbnailUrl) show the
        // regenerated image. Mirrors the line/polygon/circle create flow; without
        // this the track appears to lose its photo after an edit even though the
        // photoId was saved.
        if (res.body && res.body.photoId) {
          $.ajax({
            method: 'GET',
            url: `${__API_URI__}/photo/get/${res.body.photoId}`,
            headers: {
              Authorization: `Bearer ${token}`,
              Platform: 'Web',
              Version: `${__version__}`
            }
          })
            .done(photoRes => {
              res.body.photo = photoRes
              dispatch(trackUpdate(res.body))
              resolve(res.body)
            })
            .fail(ajaxErr => {
              console.error('Error fetching track photo details:', ajaxErr)
              // Still persist the rest of the edit if the photo fetch fails.
              dispatch(trackUpdate(res.body))
              resolve(res.body)
            })
        } else {
          dispatch(trackUpdate(res.body))
          resolve(res.body)
        }
      })
  })
}

// Rejects with the superagent error when the delete fails (WEB-7103), and only then leaves the
// object in the store; it's removed once the server confirms.
export const trackDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/measurement/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) return reject(err)
        dispatch(trackDelete(id))
        resolve(res.body)
      })
  })
}
